export default {"src":"/_next/static/media/logo-supersitters-white.60b33ceb.svg","height":346,"width":974,"blurWidth":0,"blurHeight":0};